var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status && _vm.statusLabel)?_c('div',[_c('StatusIndicator',{attrs:{"color":_vm.indicatorColour}},[_vm._v(_vm._s(_vm.statusLabel))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }